enum ViewportType {
  mobileSmall = 'mobileSmall',
  mobile = 'mobile',
  tablet = 'tablet',
  desktopSmall = 'desktopSmall',
  desktopMedium = 'desktopMedium',
  desktop = 'desktop',
}
export default ViewportType;
